import styled, { css } from 'styled-components'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT } from '../../../../styles/theme'
import { QuestionLabel, InputWrapper, interactiveBase, selectedStyle } from './shared'

interface YesNoQuestionProps {
  question: string
  value: boolean | null
  onChange: (value: boolean) => void
}

const CardRow = styled.div`
  display: flex;
  gap: ${SPACING.sm};
  width: 100%;
`

const ChoiceCard = styled.button<{ $selected: boolean }>`
  ${interactiveBase}
  flex: 1;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${SPACING.sm};
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  border-width: 1px;
  border-style: solid;
  border-radius: ${BORDER_RADIUS.lg};
  padding: ${SPACING.md};

  ${({ $selected }) =>
    $selected &&
    css`
      ${selectedStyle}
    `}
`

const RadioDot = styled.span<{ $selected: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid
    ${({ $selected }) => ($selected ? 'var(--color-primary)' : 'var(--color-border-dark)')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: border-color 0.15s ease;

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $selected }) => ($selected ? 'var(--color-primary)' : 'transparent')};
    transition: background 0.15s ease;
  }
`

const OPTIONS: { label: string; value: boolean }[] = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

export function YesNoQuestion({ question, value, onChange }: YesNoQuestionProps) {
  return (
    <InputWrapper>
      <QuestionLabel>{question}</QuestionLabel>
      <CardRow role="group" aria-label={question}>
        {OPTIONS.map((opt) => (
          <ChoiceCard
            key={opt.label}
            type="button"
            $selected={value === opt.value}
            onClick={() => onChange(opt.value)}
            aria-pressed={value === opt.value}
          >
            <RadioDot $selected={value === opt.value} />
            {opt.label}
          </ChoiceCard>
        ))}
      </CardRow>
    </InputWrapper>
  )
}
